import { Button, Input, Typography, Form } from "antd";
import { useLogin } from "../../hooks/useLogin";

const Login = () => {
  const { handleLogin } = useLogin();
  return (
    <div className="authForm">
      <div
        style={{
          width: "450px",
          padding: "2rem",
          borderRadius: 8,
        }}
      >
        <Typography.Title
          level={3}
          style={{ textAlign: "center", color: "#63B8DE" }}
        >
          Welcome Back!
        </Typography.Title>
        <Typography.Text
          style={{
            display: "block",
            textAlign: "center",
            marginBottom: "1rem",
          }}
        >
          Sign in to continue to Omnia Resourcing.
        </Typography.Text>

        <Form
          name="login"
          initialValues={{ remember: true }}
          onFinish={handleLogin}
          layout="vertical"
          requiredMark={false}
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[
              { type: "email", message: "Please enter a valid email address" },
              { required: true, message: "Please enter your email!" },
            ]}
          >
            <Input placeholder="Email" />
          </Form.Item>

          <Form.Item
            name="password"
            label="Password"
            normalize={(value) => value} // Keeps spaces intact
            rules={[
              {
                required: true,
                message: "Please enter your password!",
              },
            ]}
          >
            <Input.Password
              placeholder="Password"
              minLength={8}
              maxLength={15}
            />
          </Form.Item>

          {/* <Form.Item name="remember" style={{ marginBottom: "1rem" }}>
            <Checkbox>Remember me</Checkbox>
          </Form.Item> */}

          <Form.Item>
            <Button
              htmlType="submit"
              style={{
                background: "#63B8DE",
                width: "100%",
                color: "#fff",
                border: "1px solid #63B8DE",
              }}
              className="login-btn"
            >
              Sign In
            </Button>
          </Form.Item>
        </Form>
      </div>
      <style>
        {`
          .login-btn:hover, .login-btn:focus {
            border-color: #63B8DE !important;
          }
        `}
      </style>
    </div>
  );
};

export default Login;
